import { useBranchLimits } from "@tlc/ls2pac/components/BranchLimits";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  LocationDialog,
  LocationSummary,
} from "@tlc/ls2pac/components/LocationDialog";
import React from "react";
import { ListItemButton, ListItemText } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";

export const LocationFilterControl = () => {
  const { branchLimits, displayBranchLimitControl, selectedBranchIds } =
    useBranchLimits();
  const [locationDialogOpen, setLocationDialogOpen] = useState<boolean>(false);
  const [_, setSearchParams] = useSearchParams();
  const { translate } = useLanguage();

  if (!displayBranchLimitControl) {
    return null;
  }

  return (
    <>
      <LocationDialog
        open={locationDialogOpen}
        onSubmit={(data) => {
          setSearchParams((prev) => {
            // TODO move this to LSSearch
            const newParams = new URLSearchParams(prev);
            newParams.delete("page");
            if (!data || data.length === 0) {
              newParams.set("branchFilters", JSON.stringify([])); // need to explicitly set to [] to clear because of context fallback
            } else {
              newParams.set("branchFilters", JSON.stringify(data));
            }

            return newParams;
          });
          setLocationDialogOpen(false);
        }}
        onClose={() => {
          setLocationDialogOpen(false);
        }}
      ></LocationDialog>
      <ListItemButton
        sx={{ gap: 2 }}
        onClick={() => setLocationDialogOpen(true)}
        divider={true}
      >
        <ListItemText
          primary={translate("selectedLocations")}
          secondaryTypographyProps={{ color: "secondary" }}
          secondary={
            <LocationSummary
              branchLimits={branchLimits}
              selected={selectedBranchIds}
            />
          }
          sx={{ my: 0 }}
        />
        {/* {<ChevronRightIcon />} */}
      </ListItemButton>
    </>
  );
};
